
export enum LicenseState
{
    NoLicenseFile = 0,// Error No lic Files
    Essential = 1,//as defined in enum LicenseType
    Advanced = 2,//as defined in enum LicenseType
    Ultimate = 3,//as defined in enum LicenseType
    ExceedeLicConcurrentUsers = -3, // Concurrent users exceed the limitation
    InvalidMachineKey = -4,// Invalide Machine Key
    InvalidCertificateFile = -5,// Ivalide Certificate File
    InvalidApplicationPath = -6, //Invalide application Path
    OldVersion = -7,// old version
    ServerTypeError = -8,//
    LicenseExpired = -9

}